import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { AnalyticsContext } from '@atlaskit/analytics-next';

import { messages } from '../../messages';
import { useGetIsMissingColumnMappingError } from '../../providers/BulkCreateContextProvider';

const footerBaseStyles = xcss({
	backgroundColor: 'elevation.surface',
	position: 'relative',
	flexShrink: 0,
	bottom: 'space.0',
	width: '100%',
	'::before': {
		content: '""',
		position: 'absolute',
		top: 'space.0',
		left: 'space.150',
		right: 'space.150',
		height: '1px',
		backgroundColor: 'elevation.surface',
		borderTopColor: 'color.border',
		borderTopStyle: 'solid',
		borderTopWidth: 'border.width',
	},
});

export interface SingleWorkCreateFormFooterProps {
	onClose: () => void;
	closePanel: () => void;
	isSaveDisabled: boolean;
	onSubmit?: () => void;
}

export const SingleWorkCreateFormFooter = ({
	onClose,
	closePanel,
	isSaveDisabled,
	onSubmit,
}: SingleWorkCreateFormFooterProps) => {
	const isMissingColumnMappingError = useGetIsMissingColumnMappingError();
	// We are directly navigating the user to the configure page if there are no issues to mapped.
	// Since the configure page doesn't have a way to close the side panel, we are changing the cancel button to allow the user to close the side panel in case they don't want to proceed.
	const onCancel = isMissingColumnMappingError ? closePanel : onClose;

	return (
		<Box paddingBlock="space.200" paddingInline="space.300" xcss={footerBaseStyles}>
			<Inline space="space.100" alignInline="end">
				<AnalyticsContext data={{ attributes: { buttonName: 'workCreateFormCancelButton' } }}>
					<Button
						appearance="subtle"
						testId="single-work-create-form-cancel-button"
						onClick={onCancel}
					>
						<FormattedMessage {...messages.singleCreateIssueFormFooterCancel} />
					</Button>
				</AnalyticsContext>
				<AnalyticsContext data={{ attributes: { buttonName: 'workCreateFormSaveButton' } }}>
					<Button
						type="submit"
						form="single-work-create-form"
						appearance="primary"
						testId="single-work-create-form-save-button"
						isDisabled={isSaveDisabled}
						onClick={onSubmit}
					>
						<FormattedMessage {...messages.singleCreateIssueFormFooterSave} />
					</Button>
				</AnalyticsContext>
			</Inline>
		</Box>
	);
};
